// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nspan[data-v-67d184a2] {\n  position: fixed;\n  pointer-events: none;\n  bottom: 0;\n  left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
